import React, { Suspense, lazy } from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import App from './App.jsx'
import './index.css'

// Admin is a separate, code-split bundle — never loaded on the marketing site.
const AdminApp = lazy(() => import('./admin/AdminApp.jsx'))

// Lift the loading screen (index.html) once the app has painted. On the
// first visit of a session it stays long enough for the logo animation to
// play through; after that it leaves as soon as the app is ready.
function dismissBoot() {
  const boot = document.getElementById('boot')
  if (!boot) return
  let seen = false
  try {
    seen = sessionStorage.getItem('od_boot_seen') === '1'
    sessionStorage.setItem('od_boot_seen', '1')
  } catch { /* storage blocked: treat as a first visit */ }
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches
  const minimum = seen || reduce ? 0 : 1700
  const wait = Math.max(0, minimum - performance.now())
  setTimeout(() => {
    boot.classList.add('is-done')
    setTimeout(() => boot.remove(), 700)
  }, wait)
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route
          path="/admin/*"
          element={
            <Suspense fallback={<div className="min-h-screen grid place-items-center text-ink-3 bg-canvas">Loading…</div>}>
              <AdminApp />
            </Suspense>
          }
        />
        <Route path="/*" element={<App />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
)

requestAnimationFrame(() => requestAnimationFrame(dismissBoot))
